/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuFilterLocation_itemSearch$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
export type SbSharedRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedRefineMenuFilterLocation_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "appliedFilters",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseParsedParam",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilterLocation_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd5e62a0b54beeb62c5d83d070b4fb0bb';
export default node;
